var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.54996 9.15L14.025 0.675C14.225 0.475 14.4583 0.375 14.725 0.375C14.9916 0.375 15.225 0.475 15.425 0.675C15.625 0.875 15.725 1.1125 15.725 1.3875C15.725 1.6625 15.625 1.9 15.425 2.1L6.24996 11.3C6.04996 11.5 5.81663 11.6 5.54996 11.6C5.2833 11.6 5.04996 11.5 4.84996 11.3L0.549963 7C0.349963 6.8 0.25413 6.5625 0.262463 6.2875C0.270796 6.0125 0.374963 5.775 0.574963 5.575C0.774963 5.375 1.01246 5.275 1.28746 5.275C1.56246 5.275 1.79996 5.375 1.99996 5.575L5.54996 9.15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.c465c04077da95ea985517659442e1e2.svg";
export { ForwardRef as ReactComponent };